<template>
  <div class="header-title header-title-text title-notab">
    <v-row style="background-color: #E0EAFB;" align="end" justify="end" v-show="checkmanageAuthen === true">
      <v-col cols="8" class="d-flex align-center justify-center ">
        <span style="font-size: 14px; font-weight: bold; color: #3776E9; margin-top: -4%;" class="my-2"><v-icon left dark color="grey" size="24px">mdi-alert-circle-outline</v-icon>จัดการสิทธิ์ที่ได้มีการโอนก่อนหน้านี้</span>
      </v-col>
      <v-col cols="2" class="pt-0 pb-0 d-flex align-center justify-end mt-0 ml-5">
        <v-btn
          class="head-search-button mx-4 my-5"
          color="primary"
          elevation="0"
          style="margin-top: 0%;"
          @click="openDialogManageAuthne()"
        >
           จัดการสิทธิ์
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="" class="ma-5">
        จัดการโอนสิทธิ์
      </v-col>
      <!-- <v-col cols="12" sm="12" md="6" lg="2" class="pt-0 pb-0 d-flex align-center justify-end mt-1 ml-5">
        <v-btn
          class="head-search-button mx-2"
          style="width: 150px; height: 38px;"
          color="primary"
          elevation="0"
          @click="gotocreate()"
        >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          เพิ่ม Tag
        </v-btn>
      </v-col> -->
    </v-row>
    <DialogManageAuthen/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import DialogManageAuthen from '../_dialog/dialogManageAuthen'
export default {
  components: {
    DialogManageAuthen
  },
  data () {
    return {
      tabName: 0,
      companyTitleName: '',
      companyUID: '',
      companyNameTitle: '',
      checkBtnRegister: false,
      checkmanageAuthen: false
    }
  },
  beforeDestroy () {
    EventBus.$off('tabstitletructure')
    EventBus.$off('checkBtnRegister')
    EventBus.$off('checkManageAuthen')
  },
  mounted () {
    EventBus.$on('tabstitletructure', this.getDataTab)
    EventBus.$on('checkBtnRegister', this.checkRegister)
    EventBus.$on('checkManageAuthen', this.checkManageAuthen)
  },
  created () {
    this.tokenUser = this.$store.state.token
    this.propsitems = this.$route.params.id
    this.companyUID = this.propsitems
    this.companyNameTitle = this.$route.params.company
  },
  methods: {
    checkRegister (value) {
      this.checkBtnRegister = value
    },
    openDialogManageAuthne () {
      EventBus.$emit('openDialogManageAuthen', true)
    },
    checkManageAuthen (value) {
      this.checkmanageAuthen = value
    },
    editData (item) {
      // this.$router.push('managestructure/update/601287bd0b1f0b12d889b914')
      this.$router.push('/managestructure/update/' + item)
    },
    goBack () {
      // this.$router.push('managestructure')
      this.$router.push({
        name: 'ManageStructureOverview'
      })
    },
    getDataTab (val) {
      this.tabName = String(val)
    },
    gotocreate () {
      // this.$router.push('managebusines/create')
      this.$router.push({
        name: 'manageTransferrolecreate',
        params: {
          type: 'new',
          id: ''
        }
      })
    }
  }
}
</script>

<style>
.manage-department-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
.ra-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-button-upload {
  /* position: absolute; */
  /* height: 72px;
  left: 0px;
  right: 0px;
  top: 0px; */

  /* Color/Other/Background */

  background: #F8F9FA;
}
</style>
